export default {"src":"/_next/static/media/whatsapp_icon.a2bc9ab6.svg","height":18,"width":17};